import { render } from "./BaseMultiSelect.vue?vue&type=template&id=acf38a0c"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"

import "./BaseMultiSelect.vue?vue&type=style&index=0&id=acf38a0c&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__